import { createApp } from 'vue'
import { createRouter, createWebHistory } from 'vue-router'
import { autoAnimatePlugin } from "@formkit/auto-animate/vue";

import App from './App.vue'
import './css/app.css';

import HomePage from './pages/HomePage.vue';
import StarDex from './pages/StarDex.vue';
import MovelistGenerator from './pages/MovelistGenerator.vue';
import StatJiggler from './pages/StatJiggler.vue';
import TypingAnalyser from './pages/TypingAnalyser.vue';
import CryCreator from './pages/CryCreator.vue';

const appTitle = "PokéTools by Bitcrush";

const routes = [
  {
    path: '/',
    component: HomePage,
    meta: { title: appTitle }
  },
  {
    path: '/stardex',
    component: StarDex,
    meta: { title: 'StarDex | ' + appTitle }
  },
  {
    path: '/movelist-generator',
    component: MovelistGenerator,
    meta: { title: 'Pokémon Movelist Generator | ' + appTitle }
  },
  {
    path: '/stat-jiggler',
    component: StatJiggler,
    meta: { title: 'Pokémon Stat Jiggler | ' + appTitle }
  },
  {
    path: '/typing-analyser',
    component: TypingAnalyser,
    meta: { title: 'Pokémon Typing Analyser | ' + appTitle }
  },
  {
    path: '/cry-creator',
    component: CryCreator,
    meta: { title: 'Pokémon Cry Creator | ' + appTitle }
  },
]

const router = createRouter({
  history: createWebHistory('/poketools'),
  base: '/poketools',
  routes,
})

router.afterEach((to, from) => {
  from;
  document.title = to.meta.title || appTitle;
});


const app = createApp(App)
app.use(router)
app.use(autoAnimatePlugin)
app.mount('#app')
